module.exports = __webpack_public_path__ + "flyer_image_overlay_texture_10-c6af906a69b1dd2a59d38f64a2587060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_texture_10.png
// module id = 1573
// module chunks = 1